import { useMemo } from 'react'
import logo from '../../assets/forpy-logo-no-text.png'
import { HeaderProps } from './Header.props'
import * as S from './style'

export function Header ({ hasLogo, title }: HeaderProps): React.ReactElement {
  const handleRedirectPath = useMemo(() => {
    if (window.location.href.includes('/login')) return '/'
    if (window.location.href.includes('/cadastre-se')) return '/'
    if (window.location.href.includes('/cadastre-se')) return '/'
    if (window.location.href.includes('/recuperar-senha')) return '/'
    return '/inicio'
  }, [window.location.href])

  return <S.HeaderForpy style={{ background: 'var(--white-light)' }}>
    {hasLogo && <a href={handleRedirectPath}>
      <img className='logo' src={logo} alt='logotipo da Forpy' />
    </a>}
    {title && <h1 className='page-title'>{title}</h1>}
  </S.HeaderForpy>
}
